
export default {
  name: 'service-image-card',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
